import { ApiResponse } from '@app/_models';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '@environments/environment';
import { User } from '@app/_models';
import { AlertService } from '@app/_services';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
	private alertService: AlertService;
	private currentUserSubject: BehaviorSubject<User>;
	public currentUser: Observable<User>;

	constructor(private http: HttpClient) {
		this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
		this.currentUser = this.currentUserSubject.asObservable();
	}

	public get currentUserValue(): User {
		return this.currentUserSubject.value;
	}

	login(username: string, password: string) {
		const uid = localStorage.getItem('deviceUid');
		const loginHeaders: { [key: string]: string } = {};
		if (uid) {
			loginHeaders['uid'] = uid;
		}
		return this.http.post<ApiResponse>(`${environment.apiUrl}/users/authenticate`, { username, password, loginPortal: 'ADMIN_PORTAL' }, { headers: loginHeaders })
			.pipe(map(apiResponse => {
				console.log('login: apiResponse:' + JSON.stringify(apiResponse.data));
				// check if 2FA is required
				if (apiResponse.data.twoFactor && apiResponse.data.twoFactor.twoFactorRequired) {
					return apiResponse;
				}
				// login successful if there's a jwt token in the response
				if (apiResponse.data.user && apiResponse.data.user.token) {
					// store user details and jwt token in local storage to keep user logged in between page refreshes
					localStorage.setItem('currentUser', JSON.stringify(apiResponse.data.user));
					this.currentUserSubject.next(apiResponse.data.user);
					// persist device trust UUID separately so it survives logout (currentUser is cleared on JWT expiry)
					if (apiResponse.data.user.visitorTrackingID) {
						localStorage.setItem('deviceUid', apiResponse.data.user.visitorTrackingID);
					}
				}
				return apiResponse;
			}));
	}

	sendTwoFactorCode(userId: number, twoFactorChannel: string) {
		return this.http.post<ApiResponse>(`${environment.apiUrl}/users/send-2fa-code`, { userId, twoFactorChannel });
	}

	verifyTwoFactorCode(userId: number, twoFactorCode: string) {
		return this.http.post<ApiResponse>(`${environment.apiUrl}/users/verify-2fa`, { userId, twoFactorCode, loginPortal: 'ADMIN_PORTAL' })
			.pipe(map(apiResponse => {
				if (apiResponse.data.user && apiResponse.data.user.token) {
					localStorage.setItem('currentUser', JSON.stringify(apiResponse.data.user));
					this.currentUserSubject.next(apiResponse.data.user);
					// persist device trust UUID separately so it survives logout (currentUser is cleared on JWT expiry)
					if (apiResponse.data.user.visitorTrackingID) {
						localStorage.setItem('deviceUid', apiResponse.data.user.visitorTrackingID);
					}
				}
				return apiResponse;
			}));
	}

	logout() {
		/**this.alertService.success('Log out successful.', true);*/
		// remove user from local storage to log user out
		// NOTE: do NOT remove 'deviceUid' here — it must survive logout so the backend
		// recognises this browser on the next login and skips 2FA for 7 days.
		localStorage.removeItem('currentUser');
		localStorage.removeItem('taskSummaryCount');
		this.currentUserSubject.next(null);
	}
}
